'use client'

import React, { useActionState, useEffect, useState } from 'react'
import { useRouter } from 'next/navigation'
import classNames from 'classnames'

import Step from '@/step/Step'
import StepForm from '@//step-form/StepForm'
import Fieldset from '@/fieldset/Fieldset'
import Textfield from '@/forms/textfield/Textfield'
import FieldErrors from '@/forms/field-errors/FieldErrors'

import { EMPTY_FORM_STATE } from '@/lib/form/form'
import { t, tRich } from '@/lib/utils/helpers'
import { useLocale } from '@/lib/context/LocaleContext'
import { useTranslations } from '@/lib/context/TranslationsContext'
import { StepBasicProps } from '@/lib/types/types'
import { getEmailLoginLinkByContract } from '@/app/utils/selfServiceActions'

const FindPolicy = (props: StepBasicProps): JSX.Element => {
    const { intro, globals } = useTranslations()
    const locale = useLocale()
    const router = useRouter()
    const linkLabel = t(intro.loginLink.tryAnother, locale)
    const [url, setUrl] = useState<string>('')
    useEffect(() => {setUrl(window?.location?.href)}, [])

    const [state, formAction] = useActionState(async (state: any, payload: any) => {
        return getEmailLoginLinkByContract(state, payload, 'find-policy', locale, url)
    }, EMPTY_FORM_STATE)

    const validationErrors = state?.fieldErrors || props?.validationErrors
    const email = state?.data?.email || '';
    const redirect = state?.data?.redirect || '';
    const className = classNames('find-policy', props.className)

    useEffect(() => {
        if (redirect) {
            router.replace(redirect)
        }
    }, [redirect, router])

    return (
        <Step
            className={className}
            title={t(intro.policy.title, locale)}
            description={t(intro.policy.description, locale)}
            gapSize='large'
        >
            <StepForm className='find-policy__form' action={formAction} submitLabel={t(globals.buttons.submit.label, locale)} alternativeButton={`/${locale}?step=login-link`} linkLabel={linkLabel}>
                <Fieldset>
                    <Textfield
                        label={t(intro.policy.policyNumber, locale)}
                        name='policy_number'
                        isInvalid={!!(state?.fieldErrors?.['policy_number'])}
                        flatBottom
                    />
                    <Textfield
                        label={t(intro.policy.claimPin, locale)}
                        name='claim_pin'
                        type='number'
                        isNumeric
                        isInvalid={!!(state?.fieldErrors?.['claim_pin'])}
                        flatTop
                    />
                    {validationErrors && (
                        <FieldErrors fieldErrors={validationErrors} />
                    )}
                    {email && (
                        <p className="field-errors field-errors-success">{[tRich(intro.policy.loginLink.emailSent, locale, { email: () => email })]}</p>
                    )}
                </Fieldset>
            </StepForm >
        </Step>
    )
}

export default FindPolicy